import { useEffect } from "react";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { rememberPostLoginRedirect } from "@/helpers/postLoginRedirect";

const KEY_PATTERN = /^[a-z0-9][a-z0-9-]{0,254}$/i;

export const publicWantListingUrl = (key) => {
  const base = String(process.env.REACT_APP_PUBLIC_SITE_URL || "https://www.gitcha.com").replace(/\/$/, "");
  return `${base}/agents/want-listings/${encodeURIComponent(String(key).toLowerCase())}`;
};

export const isPublicWantListing = (details) => {
  const value = details?.syndicateToThePublic;
  return value === true || value === 1 || value === "1" || value === "true";
};

export const wantsSignIn = (search) => new URLSearchParams(search || "").get("signin") === "1";

export const shouldUsePublicPage = ({ enabled, signedIn, isGitchaDefaultWebsite, wantListingKey, details, search }) =>
  Boolean(
    enabled &&
      !signedIn &&
      isGitchaDefaultWebsite &&
      KEY_PATTERN.test(String(wantListingKey || "")) &&
      isPublicWantListing(details) &&
      !wantsSignIn(search)
  );

export const usePublicWantListingRedirect = (wantListingKey, signedIn, details) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const search = typeof window === "undefined" ? "" : window.location.search;
  const redirect = shouldUsePublicPage({
    enabled: process.env.REACT_APP_PUBLIC_WANT_LISTING_PAGES === "true",
    signedIn,
    isGitchaDefaultWebsite,
    wantListingKey,
    details,
    search,
  });
  const askedToSignIn = !signedIn && wantsSignIn(search);
  useEffect(() => {
    if (askedToSignIn) rememberPostLoginRedirect(`${window.location.pathname}`);
  }, [askedToSignIn]);
  useEffect(() => {
    if (redirect) window.location.replace(publicWantListingUrl(wantListingKey));
  }, [redirect, wantListingKey]);
  return redirect;
};
